module.exports = __webpack_public_path__ + "img/loading-gif.e4b6323e.gif";